import { render, staticRenderFns } from "./ContactListTags.vue?vue&type=template&id=6266dafc&"
import script from "./ContactListTags.vue?vue&type=script&lang=js&"
export * from "./ContactListTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports